import script from "./ObservationCompleted.vue?vue&type=script&setup=true&lang=js"
export * from "./ObservationCompleted.vue?vue&type=script&setup=true&lang=js"

import "./ObservationCompleted.vue?vue&type=style&index=0&id=7d320174&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7d320174"]])

export default __exports__